import React, { Component } from 'react';
import { Form, FormGroup, Label, Input, Button, Row } from 'reactstrap';
import { SketchPicker } from 'react-color';
import './style.scss';
import reactCSS from 'reactcss';
import Modal from '../../../../../components/UI/Modal/Modal';
import PreviewModal from './PreviewModal/index'

class WhitelabelDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            colorCode: '',
            corporateLogo: null,
            displayColorPicker: false,
            color: null,
            showPreviewModal: false,
            previewModal: null
        }
    }
    componentDidUpdate(prevProps) {
        if (this.props.initialValues !== prevProps.initialValues) {
            this.setState({
                color: this.props.initialValues.corporateColor,
                corporateLogo: [this.props.initialValues.corporateLogo],
            })
        }
    }
    handleColorChange = (color) => {
        this.setState({
            color: color.hex
        })
    }
    handleClick = () => {
        this.setState((prevState) => ({
            displayColorPicker: !prevState.displayColorPicker
        }))
    }
    uploadCorporateLogo = (event) => {
        let file = event.target.files[0];
        let reader = new FileReader();
        let url = reader.readAsDataURL(file);
        reader.onloadend = (e) => {
            this.setState({
                corporateLogo: [reader.result]
            }, () => {
                document.getElementById('logoUpload').value = "";
            })
        }
    }
    saveWhitelabel = (event) => {
        event.preventDefault();
        this.props.whitelabelCallback({ corporateLogo: this.state.corporateLogo, corporateColor: this.state.color }, true)
    }

    resetWhiteLabel = (event) => {
        event.preventDefault()
        this.setState({
            color: '#407ebc',
            corporateLogo: null
        })
        this.props.whitelabelCallback({ corporateLogo: null, corporateColor: '#407ebc' }, false)
    }
    handleToggle = () => {
        this.setState((prevState) => ({
            showPreviewModal: !prevState.showPreviewModal,
            previewModal: null
        }))
    }
    handlePreviewTheme = () => {
        this.setState((prevState) => ({
            showPreviewModal: !prevState.showPreviewModal,
            previewModal: <PreviewModal corporateColor={this.state.color} handleToggle={this.handleToggle} />
        }))
    }
    render() {
        const style = reactCSS({
            'default': {
                color: {
                    width: '100px',
                    height: '14px',
                    borderRadius: '2px',
                    background: `${this.state.color}`,
                },
                swatch: {
                    padding: '5px',
                    background: '#fff',
                    borderRadius: '1px',
                    boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
                    display: 'inline-block',
                    cursor: 'pointer',
                    float: 'left'
                },
                popover: {
                    position: 'absolute',
                    zIndex: '2',
                },
                cover: {
                    position: 'fixed',
                    top: '0px',
                    right: '0px',
                    bottom: '0px',
                    left: '0px',
                },
            },
        });
        return (
            <div>
                <Form>
                    <Row>
                        <FormGroup className="mb-4">
                            <div>
                                <Label for="colorCode">Color Code</Label>
                            </div>
                            <div style={style.swatch} onClick={this.handleClick}>
                                <div style={style.color} />
                            </div>
                            {(this.state.displayColorPicker) ? <div style={style.popover}>
                                <div style={style.cover} onClick={this.handleClick} />
                                <SketchPicker color={this.state.colorCode} onChange={this.handleColorChange} />
                            </div> : null}
                            <div className='preview-color'>
                                <span className='preview-theme-color' onClick={this.handlePreviewTheme}>preview</span>
                            </div>
                        </FormGroup>
                    </Row>
                    <Row>
                        <FormGroup className='upload-section'>
                            <div>
                                <Label for="colorCode">Upload Logo</Label>
                            </div>

                            <div className="btn position-relative upload-logo" title="Upload Corporate Logo">
                                <Input onChange={this.uploadCorporateLogo} type="file" name="logoUpload" id="logoUpload" className="upload-file" title="Upload Corporate Logo" />
                                <i className="fa fa-upload"></i>&nbsp;Upload Corporate Logo
                        </div>
                            <div className='corporate-logo'>
                                {(this.state.corporateLogo) ? <img src={this.state.corporateLogo} className="preview-image" height='28' />
                                    : <span className='preview-image preview-text'>Preview Logo</span>}

                            </div>
                        </FormGroup>
                    </Row>
                    <FormGroup className="d-flex justify-content-end">
                        <Button type="submit" className="mr-3" color="primary" onClick={this.saveWhitelabel}>Save</Button>
                        <Button type="submit" className="" color="primary" onClick={this.resetWhiteLabel}>Reset</Button>
                    </FormGroup>
                </Form>
                <Modal show={this.state.showPreviewModal} className='Modal' >
                    {this.state.previewModal}
                </Modal>
            </div>
        )
    }
}

export default WhitelabelDetails